import { useEffect, useRef, useState } from "react";
import { Mic, MicOff } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const LANG_MAP = {
  en: "en-IN", kn: "kn-IN", te: "te-IN", ta: "ta-IN", hi: "hi-IN", ml: "ml-IN",
};

export default function VoiceSearchButton({ onResult, className = "" }) {
  const { lang, t } = useI18n();
  const [listening, setListening] = useState(false);
  const [supported, setSupported] = useState(true);
  const recRef = useRef(null);

  useEffect(() => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) { setSupported(false); return; }
  }, []);

  const toggle = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return;
    if (listening) {
      try { recRef.current && recRef.current.stop(); } catch (e) { console.warn("[GTF] voice stop", e); }
      setListening(false);
      return;
    }
    const rec = new SR();
    rec.lang = LANG_MAP[lang] || "en-IN";
    rec.interimResults = false;
    rec.maxAlternatives = 1;
    rec.onresult = (e) => {
      const text = e.results?.[0]?.[0]?.transcript || "";
      if (text) onResult && onResult(text);
      setListening(false);
    };
    rec.onerror = () => setListening(false);
    rec.onend = () => setListening(false);
    recRef.current = rec;
    rec.start();
    setListening(true);
  };

  if (!supported) return null;

  return (
    <button
      type="button"
      data-testid="voice-search-btn"
      onClick={toggle}
      title={listening ? t("voice.listening") : t("voice.start")}
      className={`h-9 w-9 rounded-full flex items-center justify-center transition-all ${listening ? "bg-red-500 text-white animate-pulse" : "bg-emerald-50 text-emerald-700 hover:bg-emerald-100"} ${className}`}
    >
      {listening ? <MicOff className="h-4 w-4" /> : <Mic className="h-4 w-4" />}
    </button>
  );
}
